import type { GridRowId } from "@mui/x-data-grid-premium";

/**
 * The merged grid's row id for a manifest. The `shippingPaperwork` resolver
 * keys each item `<source>:<entity id>`, and a manifest's source is
 * `PROCESSED_MANIFEST`.
 */
const MANIFEST_ROW_ID_PREFIX = "PROCESSED_MANIFEST:";

export function manifestRowId(manifestId: string): string {
  return `${MANIFEST_ROW_ID_PREFIX}${manifestId}`;
}

/**
 * The manifest ids a bulk action may run on, out of the grid's selected ids.
 *
 * Read from ids rather than rows: the grid keeps a selection made on another
 * page or search, and has no row for it, so only the id is always there. A
 * bill-of-lading id has a different prefix and drops out rather than reaching
 * an action that would look it up in the manifest table.
 */
export function selectedManifestIds(ids: readonly GridRowId[]): string[] {
  return ids
    .map(String)
    .filter((id) => id.startsWith(MANIFEST_ROW_ID_PREFIX))
    .map((id) => id.slice(MANIFEST_ROW_ID_PREFIX.length));
}
